// eslint-disable-next-line import/prefer-default-export
export const ShiftlineSelectionTableType = Object.freeze({
    EditSelection: 1,
    ApprovedBidSummary: 2,
    SelectionSummary: 3,
    UnawardedShiftlineReport: 4,
    BiddingResultsReport: 5,
});
